export default "__VITE_ASSET__DLjvSG7A__"